<template>
  <v-app :style="{ background: $vuetify.theme.themes[theme].background }">
    <Loader />
    <SnackbarAlert />
    <DebugButton v-if="$DEBUG" />

    <!-- PERSISTENT SIDEBAR -->
    <v-navigation-drawer
      v-if="showLayout"
      v-model="drawer"
      app
      left
      width="280"
      class="bce-sidebar"
      floating
      mobile-breakpoint="960"
    >
      <div class="pa-5 d-flex justify-center align-center">
        <v-img
          :src="require('./assets/logos/frame 82.png')"
          max-width="130"
          contain
          style="cursor: pointer"
          @click="$router.push('/home')"
        ></v-img>
      </div>

      <!-- MENÚ SEARCH -->
      <div class="px-4 mb-4">
        <v-text-field
          v-model="searchMenu"
          prepend-inner-icon="mdi-magnify"
          label="Buscar..."
          solo
          flat
          hide-details
          class="rounded-lg bce-menu-search"
          background-color="#f4f7f9"
        ></v-text-field>
      </div>

      <v-list nav dense class="mt-2 px-3 bce-nav-list">
        <v-list-item
          v-for="(item, i) in menuValidar"
          :key="'menu-' + i"
          link
          :to="item.disabled ? '' : { name: item.route }"
          :disabled="item.disabled"
          active-class="bce-active-link"
          :class="[
            'mb-2 rounded-lg py-2',
            item.disabled ? 'bce-item-disabled' : ''
          ]"
        >
          <v-list-item-icon class="mr-4">
            <v-icon size="24" :color="item.disabled ? 'grey lighten-1' : ''">{{
              item.icon_bce || "mdi-menu-right"
            }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              :class="[
                'font-weight-bold text-body-1',
                item.disabled ? 'grey--text text--lighten-1' : ''
              ]"
            >
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="pa-5">
          <v-btn
            block
            color="#E50050"
            dark
            class="rounded-lg elevation-0 text-initial font-weight-bold py-5 bce-logout-btn"
            @click="logout()"
          >
            <v-icon left>mdi-logout-variant</v-icon> Cerrar Sesión
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- PERSISTENT TOPBAR -->
    <v-app-bar
      v-if="showLayout"
      app
      color="rgba(244, 247, 249, 0.85)"
      flat
      style="backdrop-filter: blur(15px); border-bottom: 1px solid rgba(0, 0, 0, 0.03)"
    >
      <v-app-bar-nav-icon
        class="d-md-none mr-2"
        color="#2c3e50"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <!-- Pequeño saludo al alumno -->
      <div class="d-none d-md-flex flex-column ml-4">
        <span class="text-subtitle-1 font-weight-bold" style="color: #2c3e50">
          Hola, {{ user.Nombres && user.Nombres.split(" ")[0] }} 👋
        </span>
        <span class="text-caption grey--text">
          Sigue construyendo tu futuro hoy
        </span>
      </div>

      <v-spacer></v-spacer>

      <!-- Ranking Widget -->
      <v-tooltip v-if="mostrarPosicion" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            v-bind="attrs"
            class="mr-3 font-weight-bold bce-chip white"
            text-color="#E50050"
            style="cursor: pointer; border: 1px solid #e50050"
            v-on="on"
            @click="modalRanking()"
          >
            <v-icon left small color="#E50050">
              mdi-trophy-variant-outline
            </v-icon>
            Ranking: #{{ posicionRanking }}
          </v-chip>
        </template>
        <span>Ver Ranking Institucional</span>
      </v-tooltip>

      <!-- Rating Widget -->
      <v-tooltip v-if="showRating" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            v-bind="attrs"
            class="mr-4 font-weight-bold bce-chip white"
            text-color="#E50050"
            style="border: 1px solid #ffb300"
            v-on="on"
          >
            <v-icon left small color="#FFB300">
              mdi-star
            </v-icon>
            {{ rating && rating.toFixed(1) }}
          </v-chip>
        </template>
        <span>Tu Reputación</span>
      </v-tooltip>

      <!-- Messages / Notifications -->
      <v-badge
        v-if="notifications.general.total > 0"
        color="#E50050"
        :content="notifications.general.total"
        overlap
        dot
      >
        <v-btn icon color="#546E7A" class="mx-1" @click="LoadNotifications()">
          <v-icon>mdi-bell-outline</v-icon>
        </v-btn>
      </v-badge>
      <v-btn
        v-else
        icon
        color="#546E7A"
        class="mx-1"
        @click="LoadNotifications()"
      >
        <v-icon>mdi-bell-outline</v-icon>
      </v-btn>

      <!-- User Profile Dropdown -->
      <v-menu
        bottom
        min-width="260px"
        rounded="xl"
        offset-y
        transition="slide-y-transition"
        nudge-bottom="10"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon large class="ml-2 mr-md-2" v-on="on">
            <v-avatar
              size="44"
              style="border: 2px solid #E50050; padding: 2px; background: white"
            >
              <img
                style="border-radius: 50%"
                :src="
                  user.imagen == null
                    ? require('./assets/user.png')
                    : imagenbs || user.imagen
                "
              />
            </v-avatar>
          </v-btn>
        </template>
        <v-card
          class="rounded-xl pa-3"
          elevation="10"
          style="border: 1px solid rgba(0, 0, 0, 0.05)"
        >
          <div class="text-center mt-3">
            <v-avatar
              size="72"
              class="mb-3"
              style="border: 3px solid #E50050; padding: 2px"
            >
              <img
                style="border-radius: 50%"
                :src="
                  user.imagen == null
                    ? require('./assets/user.png')
                    : imagenbs || user.imagen
                "
              />
            </v-avatar>
            <h3
              class="font-weight-bold pt-1"
              style="color: #2c3e50; font-size: 1.1rem; line-height: 1.2"
            >
              {{ user.Nombres }} <br />{{ user.Apellidos }}
            </h3>
            <p class="caption grey--text mt-1 mb-0">{{ user.email }}</p>
          </div>
          <v-divider class="my-3 mx-4"></v-divider>
          <v-list nav dense class="bce-profile-list px-2">
            <v-list-item
              link
              class="rounded-lg mb-1"
              @click="$router.push('profile/' + user.IDStB)"
            >
              <v-list-item-icon class="mr-3">
                <v-icon color="#9D172F">mdi-account-circle-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                  Mi Perfil
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              class="rounded-lg mb-1"
              @click="$router.push('settings')"
            >
              <v-list-item-icon class="mr-3">
                <v-icon color="#9D172F">mdi-cog-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                  Ajustes
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>

    <!-- CONTENT TRANSITION (Outside Layout Sidebar) -->
    <v-main :class="showLayout ? 'bce-main-bg' : ''">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </v-main>

    <!-- Global Dialogs -->
    <v-dialog v-model="showTerms" persistent max-width="800" scrollable>
      <v-card class="rounded-xl">
        <v-card-title class="text-h5 font-weight-bold">
          Términos y condiciones
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 400px">
          <p>
            <span style="font-weight: 400"
              >Reglamento de Alumno de Nivel Superior y Formaci&oacute;n
              Continua</span
            >
          </p>
          <ol>
            <li><span style="font-weight: 400"> Encuadre&nbsp;</span></li>
          </ol>
          <p>
            <span style="font-weight: 400"
              >1.1. El presente Reglamento se dicta en el marco de la Ley de
              Educaci&oacute;n...</span
            >
          </p>
          <p>
            Para continuar usando la plataforma, por favor acepta los términos
            actualizados.
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="#E50050"
            dark
            large
            class="rounded-lg elevation-0 px-8"
            @click="acceptTerms"
          >
            Acepto términos y condiciones
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showModalRanking"
      max-width="600"
      overlay-color="#0f172a"
      overlay-opacity="0.9"
    >
      <v-card class="rounded-xl overflow-hidden ranking-modal-elite">
        <!-- Header con Degradado -->
        <div
          class="primary white--text pa-6 text-center ranking-header-gradient"
        >
          <v-icon color="white" size="48" class="mb-2"
            >mdi-trophy-variant</v-icon
          >
          <h2 class="text-h5 font-weight-black prism-heading uppercase mb-0">
            Ranking Institucional
          </h2>
          <div class="text-caption opacity-80">
            Reconocimiento a la constancia y el esfuerzo
          </div>
        </div>

        <v-card-text class="pa-6 pt-8 bg-soft-grey">
          <!-- PODIUM TOP 3 -->
          <div
            v-if="listaRanking.length >= 3"
            class="d-flex align-end justify-center mb-10 ranking-podium px-2"
          >
            <!-- 2DO PUESTO -->
            <div class="podium-item second text-center mx-2 mx-md-4">
              <div class="avatar-wrapper mb-2">
                <v-avatar size="60" class="elevation-4 border-silver">
                  <v-icon color="grey darken-1">mdi-account</v-icon>
                </v-avatar>
                <div class="rank-badge silver">2</div>
              </div>
              <div class="text-caption font-weight-black elite-text-truncate">
                {{
                  (listaRanking[1] && listaRanking[1].nombre.split(" ")[0]) ||
                    "---"
                }}
              </div>
              <div class="text-tiny grey--text font-weight-bold">
                {{ listaRanking[1] ? listaRanking[1].cantidad : 0 }} DÍAS
              </div>
            </div>

            <!-- 1ER PUESTO (CENTRO) -->
            <div class="podium-item first text-center mx-2 mx-md-4">
              <div class="avatar-wrapper mb-3">
                <v-avatar size="85" class="elevation-8 border-gold">
                  <v-icon color="amber darken-2" large>mdi-account</v-icon>
                </v-avatar>
                <div class="rank-badge gold">
                  <v-icon x-small color="white">mdi-crown</v-icon>
                </div>
              </div>
              <div
                class="text-subtitle-2 font-weight-black elite-text-truncate"
              >
                {{
                  (listaRanking[0] && listaRanking[0].nombre.split(" ")[0]) ||
                    "---"
                }}
              </div>
              <div class="text-caption primary--text font-weight-black">
                {{ listaRanking[0] ? listaRanking[0].cantidad : 0 }} DÍAS
              </div>
            </div>

            <!-- 3ER PUESTO -->
            <div class="podium-item third text-center mx-2 mx-md-4">
              <div class="avatar-wrapper mb-2">
                <v-avatar size="50" class="elevation-4 border-bronze">
                  <v-icon color="brown darken-1">mdi-account</v-icon>
                </v-avatar>
                <div class="rank-badge bronze">3</div>
              </div>
              <div class="text-caption font-weight-black elite-text-truncate">
                {{
                  (listaRanking[2] && listaRanking[2].nombre.split(" ")[0]) ||
                    "---"
                }}
              </div>
              <div class="text-tiny grey--text font-weight-bold">
                {{ listaRanking[2] ? listaRanking[2].cantidad : 0 }} DÍAS
              </div>
            </div>
          </div>

          <!-- LISTA DEL RESTO DEL RANKING -->
          <div class="ranking-scroll-area pr-2">
            <v-card
              v-for="(lR, idx) in listaRanking"
              :key="lR.alumno_id"
              flat
              class="mb-3 rounded-xl ranking-entry d-flex align-center pa-4"
              :class="{
                'user-highlight-elite': lR.alumno_id == user.IDStB,
                'd-none':
                  idx < 3 &&
                  listaRanking.length >= 3 &&
                  lR.alumno_id != user.IDStB
              }"
            >
              <div
                class="rank-number font-weight-black mr-4"
                :class="idx < 3 ? 'primary--text' : 'grey--text'"
              >
                #{{ lR.posicion }}
              </div>
              <v-avatar size="32" color="white" class="mr-3 elevation-1">
                <v-icon size="16" color="grey">mdi-account</v-icon>
              </v-avatar>
              <div class="flex-grow-1">
                <div
                  class="text-body-2 font-weight-bold grey--text text--darken-3"
                >
                  {{ lR.nombre }}
                  <v-chip
                    v-if="lR.alumno_id == user.IDStB"
                    x-small
                    color="primary"
                    class="ml-2 font-weight-black"
                    label
                    >TÚ</v-chip
                  >
                </div>
              </div>
              <div class="text-right">
                <div class="text-body-2 font-weight-black primary--text">
                  {{ lR.cantidad }}
                </div>
                <div class="text-tiny grey--text uppercase font-weight-bold">
                  DÍAS AL DÍA
                </div>
              </div>
            </v-card>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4 bg-white d-flex justify-center">
          <v-btn
            color="primary"
            text
            class="rounded-xl font-weight-black px-10"
            @click="showModalRanking = false"
          >
            ENTENDIDO
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Loader from "../src/components/Loader";
import SnackbarAlert from "../src/components/SnackbarAlert";
import DebugButton from "../src/components/DebugButton";
import SocketConnection from "itoeste-socket";
import { DEBUG, API_SOCKET } from "../env";

export default {
  name: "App",
  components: {
    Loader,
    SnackbarAlert,
    DebugButton
  },
  data() {
    return {
      rating: 1.0,
      showRating: false,
      notifications: {
        general: { total: 0, items: [] },
        message: { total: 0, items: [] },
        post: { total: 0, items: [] }
      },
      showTerms: false,
      ws: null,
      showModalMedals: false,
      tipoMedals: 1,
      cadenaImgMedals: "oro2",
      tieneBadge: false,
      tieneBadgeInicial: false,
      posicionRanking: 0,
      showModalRanking: false,
      listaRanking: [],
      mostrarPosicion: false,
      menu: [],
      searchMenu: "",
      drawer: true
    };
  },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    token() {
      return this.$store.getters.token;
    },
    user() {
      return this.$store.getters.user;
    },
    imagenbs() {
      return this.$store.getters.imagenbs;
    },
    showLayout() {
      const excludedRoutes = ["Login", "RecoverUser", "ResetPassword"];
      return (
        this.token !== "" &&
        this.user &&
        this.user.tipoUsuario === "alumno" &&
        !excludedRoutes.includes(this.$route.name)
      );
    },
    menuValidar: function() {
      let usuario = this.user;
      if (!usuario) return [];
      let items = [];

      // Helper to capitalize each word
      const titleCase = str => {
        return str
          .toLowerCase()
          .split(" ")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      };

      if (usuario.tipoUsuario == "alumno") {
        if (usuario.validacion_inscripcion != 0) {
          const staticItems = [
            {
              text: "Inicio",
              icon_bce: "mdi-view-dashboard-outline",
              route: "Home"
            },
            {
              text: "Mis Materias",
              icon_bce: "mdi-book-open-page-variant-outline",
              route: "MisMaterias"
            }
          ];

          let baseMenu = this.menu.filter(m =>
            m.tipoUsuario.includes(usuario.tipoUsuario)
          );

          const additionalItems = [
            {
              text: "Inscripciones Exámenes",
              icon_bce: "mdi-clipboard-check-outline",
              route: "examenes"
            },
            {
              text: "Rendir Exámenes",
              icon_bce: "mdi-pencil-outline",
              route: "rendir-examenes"
            },
            {
              text: "Mis Pagos",
              icon_bce: "mdi-cash-multiple",
              route: "pagos"
            },
            {
              text: "Classroom",
              icon_bce: "mdi-school-outline",
              route: "classroom"
            },
            {
              text: "Materias Faltantes",
              icon_bce: "mdi-book-remove-multiple-outline",
              route: "materias-faltantes"
            }
          ];

          let allItems = [...staticItems, ...baseMenu, ...additionalItems];
          let uniqueItems = [];

          // List of routes to disable if student is inactive (borrado/mora)
          const protectedRoutes = [
            "MisMaterias",
            "examenes",
            "rendir-examenes",
            "classroom",
            "materias-faltantes",
            "Foro",
            "ForoCategoria",
            "Detalle",
            "Chat",
            "Tramite",
            "Horario",
            "Secretaria",
            "Nota",
            "Documento",
            "DocumentosSolicitados"
          ];

          allItems.forEach(item => {
            let normalizedText = titleCase(item.text);

            if (
              normalizedText !== "Salir" &&
              !uniqueItems.find(
                i => i.text.toLowerCase() === normalizedText.toLowerCase()
              )
            ) {
              let isDisabled =
                (usuario.borrado == "1" || usuario.alumno_mora) &&
                protectedRoutes.includes(item.route);
              let newItem = {
                ...item,
                text: normalizedText,
                disabled: isDisabled
              };
              uniqueItems.push(newItem);
            }
          });
          items = uniqueItems;
        }
      } else {
        items = this.menu
          .filter(m => m.tipoUsuario.includes(usuario?.tipoUsuario))
          .map(item => ({
            ...item,
            text: titleCase(item.text),
            disabled: false
          }));
      }

      if (this.searchMenu) {
        return items.filter(item =>
          item.text.toLowerCase().includes(this.searchMenu.toLowerCase())
        );
      }
      return items;
    }
  },
  mounted() {
    this.$store.dispatch("loader", false);
    this.initGlobalLogic();
  },
  methods: {
    initGlobalLogic() {
      console.log("Iniciando Global Logic...", this.user);
      if (
        this.user &&
        this.user.IDStB &&
        this.user.tipoUsuario &&
        this.user.tipoUsuario.toLowerCase() === "alumno"
      ) {
        // Forzamos visibilidad para asegurar que se rendericen
        this.showRating = true;
        this.mostrarPosicion = true;

        // Fetch Alumno data
        this.$API.get({ url: "alumno/getAlumno", data: {} }).then(res => {
          console.log("getAlumno res:", res);
          if (res) {
            let data = res.data || res;
            this.rating = data.puntaje || 0;
            this.showTerms = data.terms == 1 ? false : true;
            this.$store.dispatch("user", {
              ...this.user,
              borrado: data.Borrado,
              alumno_mora: data.alumno_mora,
              validacion_inscripcion: data.validacion_inscripcion,
              pendiente_documentos_inscripcion:
                data.pendiente_documentos_inscripcion
            });
          }
        });

        this.$API.get({ url: "alumno/obtenerPosicion", data: {} }).then(res => {
          console.log("obtenerPosicion res:", res);
          if (res) {
            let data = res.data || res;
            this.posicionRanking = data.posicion || 0;
          }
        });

        // Fetch Menús backend
        if (this.$store.getters.menu && this.$store.getters.menu.length > 0) {
          this.menu = this.$store.getters.menu;
        } else {
          this.$API.get({ url: "menus/B", data: {} }).then(res => {
            if (res && res.menus) {
              this.menu = res.menus;
              this.$store.dispatch("menu", res.menus);
            }
          });
        }

        // Fetch Notifications
        this.$API.get({ url: "notifications-total", data: {} }).then(res => {
          if (res) {
            let total = 0;
            res.forEach(n => {
              total += parseInt(n.total) || 0;
            });
            this.notifications.general.total = total;
          }
        });

        // Socket
        this.ws = SocketConnection(
          {
            debug: DEBUG,
            token: API_SOCKET,
            user: this.user.IDStB
          },
          () => {}
        );

        this.ws.subscribeChannel("notification-" + this.user.IDStB, () => {
          this.notifications.general.total++;
        });

        this.ws.subscribeChannel("chat-" + this.user.IDStB, result => {
          let ch = JSON.parse(result.message);
          if (ch.alumno_id !== this.user.IDStB) {
            this.notifications.general.total++;
          }
        });
      }
    },
    async logout() {
      await this.$API
        .get({ url: "alumno/logout?web=true", data: {} })
        .then(() => {
          setTimeout(() => {
            this.$store.dispatch("token", "");
            this.$store.dispatch("user", {});
            this.$store.dispatch("menu", []);
            this.$router.replace({ name: "Login" });
          }, 1000);
        });
    },
    modalRanking() {
      this.showModalRanking = true;
      this.$API.get({ url: "alumno/obtenerRanking", data: {} }).then(res => {
        this.listaRanking = res;
      });
    },
    async LoadNotifications() {
      this.$API.get({ url: "notifications?per_page=5" }).then(res => {
        this.notifications["general"].items = res.data;
        if (this.notifications["general"].total > 0) {
          this.$API.post({ url: "notifications-reset", data: {} }, false);
        }
      });
    },
    changePassword() {
      this.$router.push({ name: "ChangePassword" });
    },
    acceptTerms() {
      this.$API.post({ url: "alumno/acceptTerms", data: {} }).then(res => {
        if (res) {
          this.showTerms = false;
          this.initGlobalLogic();
        }
      });
    }
  },
  watch: {
    token(newVal) {
      if (newVal) this.initGlobalLogic();
      else {
        if (this.ws) {
          this.ws.disconnect();
          this.ws = null;
        }
      }
    },
    user: {
      handler(newVal) {
        if (newVal && newVal.IDStB && !this.mostrarPosicion) {
          this.initGlobalLogic();
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
<style>
html,
body,
.v-application {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}

/* Base Dashboard Styling */
.bce-sidebar {
  background-color: #ffffff !important;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.03) !important;
  border-right: none !important;
}

.bce-nav-list .v-list-item {
  transition: all 0.3s ease;
  color: #546e7a !important;
}
.bce-nav-list .v-list-item .v-icon {
  color: #546e7a !important;
  transition: all 0.3s ease;
}
.bce-nav-list .v-list-item:hover {
  background-color: #fce4ec !important; /* Soft Primary Hover */
  transform: translateX(5px);
}
.bce-nav-list .v-list-item:hover:not(.bce-active-link) .v-icon,
.bce-nav-list .v-list-item:hover:not(.bce-active-link) .v-list-item__title {
  color: #e50050 !important;
}
.bce-nav-list .v-list-item:hover.bce-active-link .v-icon,
.bce-nav-list .v-list-item:hover.bce-active-link .v-list-item__title {
  color: #ffffff !important;
}
.bce-active-link {
  background: linear-gradient(135deg, #e50050, #9d172f) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 15px rgba(229, 0, 80, 0.3) !important;
}
.bce-active-link .v-list-item__icon .v-icon,
.bce-active-link .v-list-item__content .v-list-item__title {
  color: #ffffff !important;
}

.bce-logout-btn {
  transition: all 0.3s ease;
}
.bce-logout-btn:hover {
  background-color: #9d172f !important;
  box-shadow: 0 6px 20px rgba(229, 0, 80, 0.4) !important;
}

/* Glassmorphism Cards for content */
.glass-card {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(20px) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important;
}

.bce-item-disabled {
  opacity: 0.6;
  cursor: not-allowed !important;
  pointer-events: all !important;
}

.bce-item-disabled:hover {
  background-color: transparent !important;
  transform: none !important;
}

/* Premium Animations */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* Scrollbar customization */
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #e50050;
}

/* Ranking Modal Elite Styles */
.ranking-modal-elite {
  position: relative;
}
.ranking-header-gradient {
  background: linear-gradient(135deg, #e50050 0%, #9d172f 100%);
  border-bottom: 4px solid rgba(255, 255, 255, 0.1);
}

.ranking-podium {
  padding-bottom: 20px;
  border-bottom: 1px dashed #e2e8f0;
}

.podium-item .avatar-wrapper {
  position: relative;
  display: inline-block;
}
.podium-item.first {
  transform: scale(1.1);
  z-index: 2;
  margin-top: -10px;
}

.rank-badge {
  position: absolute;
  bottom: -5px;
  right: -5px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 900;
  color: white;
  border: 2px solid white;
}

.gold {
  background: linear-gradient(to bottom, #ffd700, #ff8c00);
}
.silver {
  background: linear-gradient(to bottom, #c0c0c0, #808080);
}
.bronze {
  background: linear-gradient(to bottom, #cd7f32, #8b4513);
}

.border-gold {
  border: 3px solid #ffd700 !important;
}
.border-silver {
  border: 3px solid #c0c0c0 !important;
}
.border-bronze {
  border: 3px solid #cd7f32 !important;
}

.ranking-scroll-area {
  max-height: 400px;
  overflow-y: auto;
}

.ranking-entry {
  background: white;
  border: 1px solid #f1f5f9 !important;
  transition: all 0.3s ease;
}

.user-highlight-elite {
  background: white !important;
  border: 2px solid #e50050 !important;
  box-shadow: 0 0 15px rgba(229, 0, 80, 0.15) !important;
  transform: scale(1.02);
}

.elite-text-truncate {
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bg-soft-grey {
  background: #f8fafc;
}
.prism-heading {
  font-family: "Outfit", sans-serif !important;
  letter-spacing: 1px;
}
.text-tiny {
  font-size: 0.65rem !important;
}
.opacity-80 {
  opacity: 0.8;
}
.uppercase {
  text-transform: uppercase;
}
</style>
